import { Helper } from "../../util/helper.js";
import { BaseColumn, DataEntryColumn, MultiColumn, ValidationResult, ValidationResultType } from "./editableGrid.js";

export class ValidationBuilder {
    private validationResults: ValidationResult[] = [];
    private maxResultType: ValidationResultType = null;

    private setMaxResultType = (type: ValidationResultType) => {
        if (this.maxResultType == ValidationResultType.Error)
            return;
        if (this.maxResultType == ValidationResultType.Warning && type == ValidationResultType.Info)
            return;

        this.maxResultType = type;
    }

    public addInfo(condition: boolean, message: string) {
        if (!condition)
            return this;

        this.validationResults.push({ validationMessage: message, validationResultType: ValidationResultType.Info });
        this.setMaxResultType(ValidationResultType.Info);
        return this;
    }

    public addWarning(condition: boolean, message: string) {
        if (!condition)
            return this;

        this.validationResults.push({ validationMessage: message, validationResultType: ValidationResultType.Warning });
        this.setMaxResultType(ValidationResultType.Warning);
        return this;
    }

    public addError(condition: boolean, message: string) {
        if (!condition)
            return this;

        this.validationResults.push({ validationMessage: message, validationResultType: ValidationResultType.Error });
        this.setMaxResultType(ValidationResultType.Error);
        return this;
    }

    public checkReqiredFields(columns: BaseColumn[], dataItem: any) {
        let translation: string = Helper.getTranslation("Standard.Pflichtfeld");

        for (let column of columns) {
            if (column instanceof DataEntryColumn) {
                this.addError(column.required && column.required(dataItem) && (!Helper.hasValue(dataItem[column.field]) || dataItem[column.field] === ""),
                    translation.replace("\"{0}\"", column.title));
            }
            if (column instanceof MultiColumn) {
                this.checkReqiredFields(column.columns, dataItem);
            }
        }
        return this;
    }

    public build(): ValidationResult {
        if (this.validationResults.length == 0)
            return null;

        return {
            validationMessage: this.validationResults.map(x => x.validationMessage).join("\r\n"),
            validationResultType: this.maxResultType
        };
    }
}